import { render, staticRenderFns } from "./Rulements.vue?vue&type=template&id=2c827f36&scoped=true&"
import script from "./Rulements.vue?vue&type=script&lang=js&"
export * from "./Rulements.vue?vue&type=script&lang=js&"
import style0 from "./Rulements.vue?vue&type=style&index=0&id=2c827f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c827f36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VApp,VBtn,VCard,VCol,VIcon,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VListItemTitle,VPagination})
